module.exports = __webpack_public_path__ + "static/media/pricing.d8121bd8.jpg";